import * as ActionTypes from '../constants/actionTypes'
import { userCreate, userRead, userUpdate, userDelete } from '../api/user'

export const editForm = formFieldsChange => ({
  type: ActionTypes.USERFORM_EDITFORM_CHANGE,
  field: formFieldsChange,
})

export const reset = () => ({
  type: ActionTypes.USERFORM_ENTER_RESET,
})

export const fetchItem = values => (dispatch) => {
  dispatch({ type: ActionTypes.USERFORM_FETCHITEM_LOAD })

  userRead(values).then((res) => {
    const item = res.result

    dispatch({
      type: ActionTypes.USERFORM_FETCHITEM_SUCCEED,
      item,
    })
    dispatch({
      type: ActionTypes.USERFORM_EDITFORM_CHANGE,
      field: {
        id: { name: 'idnum', value: item.idnum },
        s_name: { name: 's_name', value: item.s_name },
        s_login: { name: 's_login', value: item.s_login },
        n_lock: { name: 'n_lock', value: item.n_lock === '1' },
      },
    })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.USERFORM_FETCHITEM_FAIL,
      fetchItemError: 'Ошибка получения данных по пользователю.',
    })
  })
}

export const createItem = values => (dispatch) => {
  // console.log(values)
  dispatch({ type: ActionTypes.USERFORM_CREATEITEM_LOAD })
  userCreate(values).then(() => {
    dispatch({ type: ActionTypes.SELLERLIST_CHANGETABLE_CHANGE })
    dispatch({ type: ActionTypes.USERFORM_CREATEITEM_SUCCEED })
    dispatch({ type: ActionTypes.USERFORM_ENTER_RESET })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.USERFORM_CREATEITEM_FAIL,
      createItemError: 'Ошибка создания пользователя.',
    })
  })
}

export const editItem = params => (dispatch) => {
  dispatch({ type: ActionTypes.USERFORM_EDITITEM_LOAD })

  userUpdate(params).then(() => {
    dispatch({ type: ActionTypes.USERFORM_EDITITEM_SUCCEED })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.USERFORM_EDITITEM_FAIL,
      editItemError: 'Ошибка изменения данных.',
    })
  })
}

export const deleteItem = values => (dispatch) => {
  dispatch({ type: ActionTypes.USERFORM_DELETEITEM_LOAD })

  userDelete(values).then(() => {
    dispatch({ type: ActionTypes.USERFORM_DELETEITEM_SUCCEED })
    dispatch({ type: ActionTypes.USERFORM_ENTER_RESET })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.USERFORM_DELETEITEM_FAIL,
      deleteItemError: 'Ошибка удаления пользователя.',
    })
  })
}



// WEBPACK FOOTER //
// src/actions/userForm.js